import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/index"),
    },
    {
      path: "/articleList",
      name: "articleList",
      component: () => import("@/views/articleList"),
    },
    {
      path: "/detail",
      name: "detail",
      component: () => import("@/views/detail"),
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/views/search"),
    },
    {
      path: "/staticWeb",
      name: "staticWeb",
      component: () => import("@/views/staticWeb"),
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js